import { Modal } from "antd";
import { useState } from "react";
import { RobotForm } from "./RobotForm";

/**
 * Reusable Modal for Adding a Robot
 */
export const AddRobotModal = ({
  visible,
  robot,
  robotTypes,
  organizations,
  onOk,
  onCancel,
  onChange,
}) => {
  const [iconMode, setIconMode] = useState("gallery");

  return (
    <Modal title="Add New Robot" open={visible} onOk={onOk} onCancel={onCancel}>
      <RobotForm
        robot={robot}
        robotTypes={robotTypes}
        organizations={organizations}
        onChange={onChange}
        isEditing={false}
        iconMode={iconMode}
        onIconModeChange={setIconMode}
      />
    </Modal>
  );
};

/**
 * Reusable Modal for Editing a Robot
 */
export const EditRobotModal = ({
  visible,
  robot,
  robotTypes,
  organizations,
  users,
  onOk,
  onCancel,
  onChange,
  showOwner = false,
}) => {
  const [iconMode, setIconMode] = useState("gallery");

  return (
    <Modal
      title="Edit Robot Details"
      open={visible}
      onOk={onOk}
      onCancel={onCancel}
    >
      <RobotForm
        robot={robot}
        robotTypes={robotTypes}
        organizations={organizations}
        users={users}
        onChange={onChange}
        isEditing={true}
        showOwner={showOwner}
        iconMode={iconMode}
        onIconModeChange={setIconMode}
      />
    </Modal>
  );
};
